import { RiskyPregnancyCertificateDto, RiskyPregnancyDto } from '@app/data/dtos/ptrab/certificates/certificates.dto';
import { IDataResponse } from '@app/entities/interfaces/data/data.interface';
import { RiskyPregnancyCertificate } from '@app/entities/models/ptrab/certificates/risky-pregnancy.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapRiskyPregnancyCertificate: MapFromFn<RiskyPregnancyCertificateDto, RiskyPregnancyCertificate> = (
  value
) =>
  Builder.forModel(RiskyPregnancyCertificate)
    .companyCode(value.company_code)
    .companyName(value.company_name)
    .certType(value.cert_type)
    .employeeNumber(value.employee_number)
    .startDate(value.start_date)
    .build();

export const mapRiskyPregnancyCertificateData: MapFromFn<
  IDataResponse<RiskyPregnancyDto>,
  RiskyPregnancyCertificate[]
> = (value) => value.data.period_data.map(mapRiskyPregnancyCertificate);
